import { FetchActiveTrialsRequestTypes } from '../actions/ActiveTrialsActions';
const initialState = [];
const activeTrials = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchActiveTrialsRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }
    default:
      return state;
  }
};
export default activeTrials;